import React, { useEffect } from 'react';
import { FieldArray } from 'formik';
import { Row, Col, Card, CardBody, CardHeader, Button, Table, InputGroup } from 'reactstrap';
import InputField from '../Utils/InputField';
import { handleChangeForAttributeValue } from "../Customers/constants/HandleChangeFunctions";
import { Link } from 'react-router-dom';
import { isEmptyOrInvalidField } from '../Customers/constants/constantFunctions';

const AttributeListForm = ({ values, handleChange, errors, touched, setTouched, setFieldValue, setFieldTouched, initialValues, isEdit, formInitialValues }) => {

    const initializeDefaultRow = () => {
        const defaultRow = { name: '', value: '' };
        setFieldValue('attributeList', [defaultRow]);

        setTouched({
            ...touched,
            attributeList: {
                0: {
                    name: false,
                    value: false,
                },
            },
        });
    };

    const handleAddAttribute = (push) => {
        const lastIndex = values.attributeList?.length - 1;
        if (lastIndex === -1 || !isEmptyOrInvalidField(lastIndex, values)) {
            push({ name: '', value: '' });
            setTouched({
                ...touched,
                attributeList: {
                    ...touched.attributeList,
                    [values.attributeList?.length]: {
                        name: false,
                        value: false,
                    },
                },
            });
        }
    };

    const handleClearCurrentRow = (index) => {
        setFieldValue(`attributeList[${index}].name`, '');
        setFieldValue(`attributeList[${index}].value`, '');

        setTouched({
            ...touched,
            attributeList: {
                ...touched.attributeList,
                [index]: {
                    name: false,
                    value: false,
                },
            },
        });
    };

    const isFieldFilled = (field) => {
        return field.name && field.value;
    };

    const shouldShowValidation = (index) => {
        if (isEdit && index === 0 && (!formInitialValues.attributeList || formInitialValues.attributeList.length === 0)) {
            return false;
        }
        return true;
    };

    useEffect(() => {
        if (!values.attributeList || values.attributeList.length === 0) {
            initializeDefaultRow();
        }
    }, [values.attributeList, isEdit, formInitialValues]);

    const attributeList = values.attributeList || [{ name: '', value: '' }];

    return (
        <Row className='border-1 border mt-1 '>
            <Col lg={12}>
                <FieldArray name="attributeList">
                    {({ push, remove }) => (


                        <CardBody >
                            <h4 className="card-title mb-0 flex-grow-1 p-2 mt-2">Attributes</h4>

                            <div className="live-preview">
                                <div className="table-responsive" style={{ overflow: 'visible' }}>
                                    <div>
                                        <Table className="table-borderless align-middle table-nowrap mb-4">
                                            <thead>
                                                <tr>
                                                    <th scope="col" style={{ width: '35%' }}>Name</th>
                                                    <th scope="col" style={{ width: '35%' }}>Value</th>
                                                    <th scope="col" style={{ width: '30%' }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {attributeList.map((val, index) => {
                                                    const isCurrentRowFilled = isFieldFilled(attributeList[index]);
                                                    const showValidation = shouldShowValidation(index);

                                                    return (
                                                        <tr key={index}>
                                                            <td style={{ width: '35%' }}>
                                                                <InputGroup>
                                                                    <InputField
                                                                        name={`attributeList[${index}].name`}
                                                                        className={
                                                                            (touched.attributeList &&
                                                                                touched.attributeList[index] &&
                                                                                !values.attributeList[index].name &&
                                                                                showValidation) ? 'is-invalid' : ''
                                                                        }
                                                                        placeholder="Enter name"
                                                                        type="text"
                                                                        handleChange={handleChangeForAttributeValue(handleChange)}
                                                                        value={attributeList[index].name || ""}
                                                                        invalid={
                                                                            errors.attributeList &&
                                                                            errors.attributeList[index] &&
                                                                            touched.attributeList &&
                                                                            touched.attributeList[index] &&
                                                                            touched.attributeList[index].name &&
                                                                            showValidation
                                                                        }
                                                                        showError={showValidation}
                                                                    />
                                                                </InputGroup>
                                                                {errors.attributeList &&
                                                                    errors.attributeList[index] &&
                                                                    touched.attributeList &&
                                                                    touched.attributeList[index] &&
                                                                    touched.attributeList[index].name &&
                                                                    showValidation && (
                                                                        <p className="text-danger">
                                                                            {errors.attributeList[index].name}
                                                                        </p>
                                                                    )}
                                                            </td>
                                                            <td style={{ width: '35%' }}>
                                                                <InputGroup>
                                                                    <InputField
                                                                        name={`attributeList[${index}].value`}
                                                                        className={
                                                                            (touched.attributeList &&
                                                                                touched.attributeList[index] &&
                                                                                !values.attributeList[index].value &&
                                                                                showValidation) ? 'is-invalid' : ''
                                                                        }
                                                                        placeholder="Enter value"
                                                                        type="text"
                                                                        handleChange={handleChangeForAttributeValue(handleChange)}
                                                                        value={attributeList[index].value || ""}
                                                                        invalid={
                                                                            errors.attributeList &&
                                                                            errors.attributeList[index] &&
                                                                            touched.attributeList &&
                                                                            touched.attributeList[index] &&
                                                                            touched.attributeList[index].value &&
                                                                            showValidation
                                                                        }
                                                                        showError={showValidation}
                                                                    />
                                                                </InputGroup>
                                                                {errors.attributeList &&
                                                                    errors.attributeList[index] &&
                                                                    touched.attributeList &&
                                                                    touched.attributeList[index] &&
                                                                    touched.attributeList[index].value &&
                                                                    showValidation && (
                                                                        <p className="text-danger">
                                                                            {errors.attributeList[index].value}
                                                                        </p>
                                                                    )}
                                                            </td>
                                                            <td style={{ width: '30%' }}>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    {isCurrentRowFilled && (
                                                                        <>
                                                                            <div>
                                                                                <i
                                                                                    className="mdi mdi-plus-circle-outline fs-5 text-primary me-1"
                                                                                    role="button"
                                                                                    onClick={() => handleAddAttribute(push)}
                                                                                ></i>
                                                                            </div>

                                                                            <i
                                                                                className="ri-close-line fw-bold align-middle fs-4 cross-icon-color"
                                                                                role="button"
                                                                                onClick={() => handleClearCurrentRow(index)}
                                                                            ></i>
                                                                        </>
                                                                    )}

                                                                    {index > 0 && !isCurrentRowFilled && (
                                                                        <Link
                                                                            to="#"
                                                                            className="link-danger fs-5"
                                                                            onClick={() => {
                                                                                remove(index);
                                                                                if (attributeList.length === 1) {
                                                                                    initializeDefaultRow();
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i
                                                                                data-testid="delete"
                                                                                className="ri-delete-bin-5-line"
                                                                            ></i>
                                                                        </Link>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </CardBody>

                    )}
                </FieldArray>
            </Col>
        </Row>
    );
};

export default AttributeListForm;